import Text from 'components/Text/Text';
import React, { SetStateAction } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import classNames from 'classnames';
import style from './PushesModeSwitch.module.scss';

interface IPushesModeSwitch {
	pushesMode: 'pushes' | 'schedule';
	setPushesMode: React.Dispatch<SetStateAction<'pushes' | 'schedule'>>;
}

const PushesModeSwitch: React.FC<IPushesModeSwitch> = ({ pushesMode, setPushesMode }) => {
	const switchPushesMode = (e: RadioChangeEvent) => {
		setPushesMode(e.target.value);
	};

	const switchButtonClasses = (value: 'pushes' | 'schedule') => {
		return classNames(style.switchButton, { [style.active]: pushesMode === value });
	};

	return (
		<Radio.Group
			className={style.pushesSwitch}
			buttonStyle="solid"
			size="large"
			defaultValue={pushesMode}
			onChange={switchPushesMode}>
			<Radio.Button className={switchButtonClasses('pushes')} value="pushes">
				<Text translationNameSpace="form" translationKey="pushesButton" asFragment={true} />
			</Radio.Button>
			<Radio.Button className={switchButtonClasses('schedule')} value="schedule">
				<Text translationNameSpace="form" translationKey="scheduleForPushesButton" asFragment={true} />
			</Radio.Button>
		</Radio.Group>
	);
};

export default PushesModeSwitch;
